export default "__VITE_ASSET__5XeI5oC6__"